<template>
    <v-nested-elements :items="displayedElements"/>
  </template>

<script>
import { ref, onMounted } from 'vue';

export default {
    name: 'v-gradual-text',
    props: {
        message: {
            type: String,
            required: true
        },
    },
    setup(props) {
        const displayedElements = ref([]);

        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

        function latestArrayItem(arr, bool = false, oldArr) {
            if (arr?.length == 0) return arr;
            let latest = arr?.at?.(-1);
            if (latest?.children) {
                return latestArrayItem(latest?.children, bool, bool ? arr : undefined);
            }
            if (bool) return oldArr;
            return arr;
        }

        const processNode = async (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                const words = node.textContent.trim().split(/\s+/).map(word => ({
                    tag: 'span',
                    content: word == '' ? '' :  word + '\u00A0',
                    class: 'word'
                }));

                const result = [];
                for (const word of words) {
                    result.push(word);
                    latestArrayItem(displayedElements.value).push(word);
                    await delay(110);
                }
                return result;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const children = [];
                // latestArrayItem(displayedElements.value, true, displayedElements.value).push({
                //     tag: 'span',
                //     class: 'word',
                //     content: ''
                // });
                latestArrayItem(displayedElements.value).push({
                    tag: node.tagName.toLowerCase(),
                    class: '',
                    children: []
                });
                for (const childNode of Array.from(node.childNodes)) {
                    if (childNode.nodeType === Node.ELEMENT_NODE) {
                        // latestArrayItem(displayedElements.value).push({
                        //     nice: true,
                        //   tag: childNode.tagName.toLowerCase(),
                        //   class: '',
                        //   children: [],
                        // });
                    }
                    const processedChildren = await processNode(childNode);
                children.push(...processedChildren);
                }
                latestArrayItem(displayedElements.value, true, displayedElements.value).push({
                    tag: 'span',
                    class: 'word',
                    content: ''
                });
                return [{
                    tag: node.tagName.toLowerCase(),
                    class: '',
                    children
                }];
            }
            return [];
        };

        const splitAndDisplay = async (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const rootNodes = Array.from(doc.body.childNodes);

        for (const node of rootNodes) {
            await processNode(node);
            // const processedNode = await processNode(node);
            displayedElements.value.push({
                tag: 'span',
                class: 'word',
                content: ''
            });
        }
            console.log('displayedElements', displayedElements.value);
        };

        onMounted(() => {
            splitAndDisplay(props.message);
        });

        return {
            displayedElements
        };
    }
};
</script>

<style>

.word {
    opacity: 0;
    display: inline-block;
    animation: fadeIn .5s forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

p:empty {
    display: none !important;
}
.word:empty {
    display: none !important;
}
</style>
  